/* tslint:disable */
/* eslint-disable */
export enum NavStep {
  Plansettings = 'plansettings',
  Planner = 'planner',
  Cycles = 'cycles',
  Accessory = 'accessory',
  Result = 'result'
}
